import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
var AnchorComponent = /** @class */ (function () {
    function AnchorComponent() {
    }
    AnchorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'item-anchor',
                    template: "\n        <a *ngIf=\"url\" href=\"{{ url }}\" target=\"{{ target }}\" class=\"{{ cls }}\"><span *ngIf=\"icon\" class=\"icon icon-{{ icon }}\"></span>{{ txt }}</a>\n        <a *ngIf=\"!url\" href=\"javascript:void(0);\" target=\"{{ target }}\" class=\"{{ cls }}\"><span *ngIf=\"icon\" class=\"icon icon-{{ icon }}\"></span>{{ txt }}</a>\n    ",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    AnchorComponent.propDecorators = {
        url: [{ type: Input }],
        target: [{ type: Input }],
        cls: [{ type: Input }],
        txt: [{ type: Input }],
        icon: [{ type: Input }]
    };
    return AnchorComponent;
}());
export { AnchorComponent };
//# sourceMappingURL=anchor.component.js.map